import * as Yup from "yup";

import {
  DashboardFormAlertsDefaults,
  DashboardFormAlertsFields,
  DashboardFormAlertsSchema,
} from "@/pages/dashboard/edit/subforms/dashboardFormAlerts.types.ts";
import {
  DashboardFormChartsDefaults,
  DashboardFormChartsFields,
  DashboardFormChartsSchema,
} from "@/pages/dashboard/edit/subforms/dashboardFormCharts.types.ts";
import {
  DashboardFormChecksDefaults,
  DashboardFormChecksFields,
  DashboardFormChecksSchema,
} from "@/pages/dashboard/edit/subforms/dashboardFormChecks.types.ts";
import {
  DashboardFormGeneralDefaults,
  DashboardFormGeneralFields,
  DashboardFormGeneralSchema,
} from "@/pages/dashboard/edit/subforms/dashboardFormGeneral.types.ts";
import {
  DashboardFormMetricsDefaults,
  DashboardFormMetricsFields,
  DashboardFormMetricsSchema,
} from "@/pages/dashboard/edit/subforms/dashboardFormMetrics.ts";

export const enum DashboardFormTabs {
  GENERAL = "General",
  CONTENT = "Content",
}

export interface DashboardFormFields
  extends
    DashboardFormGeneralFields,
    DashboardFormMetricsFields,
    DashboardFormChecksFields,
    DashboardFormChartsFields,
    DashboardFormAlertsFields {}

export const DashboardFormSchema = Yup.object()
  .concat(DashboardFormGeneralSchema)
  .concat(DashboardFormMetricsSchema)
  .concat(DashboardFormChecksSchema)
  .concat(DashboardFormChartsSchema)
  .concat(DashboardFormAlertsSchema);

export const DashboardFormDefaults = {
  ...DashboardFormGeneralDefaults,
  ...DashboardFormMetricsDefaults,
  ...DashboardFormChecksDefaults,
  ...DashboardFormChartsDefaults,
  ...DashboardFormAlertsDefaults,
} as DashboardFormFields;
